import PropTypes from 'prop-types';
import React from 'react';
import { Container } from 'react-bootstrap';
import { TrendSignalChart } from './TrendSignalChart';
import { TrendSignalKPIList } from './TrendSignalKPIList';
import LoadingStatusWrapper from 'sharedComponents/WithLoadingStatus/LoadingStatusWrapper';
import './styles.scss';

const TrendSignalComponent = (props) => {
    const { model } = props;
    return <Container fluid id='assistance-trend-container'>
        <LoadingStatusWrapper useCustomAnchor transparent loadingStatus={[model.trendKPIsLoadingStatus, model.trendDataLoadingStatus]} >
            <TrendSignalChart asset={props.selectedAsset} />
            <TrendSignalKPIList asset={props.selectedAsset} />
        </LoadingStatusWrapper>
    </Container>;
};

TrendSignalComponent.propTypes = {
    model: PropTypes.shape({
        trendKPIsLoadingStatus: PropTypes.string, // Loading status of the trend KPIs
        trendDataLoadingStatus: PropTypes.string, // Loading status of the trend data
    }), // Model containing state data
    selectedAsset: PropTypes.shape({
        id: PropTypes.string, // Asset ID
        name: PropTypes.string, // Asset name
    }), // Selected asset details
};

export default TrendSignalComponent;
